import Image, { type ImageProps } from 'next/image';
import PaywallProBgRebrand from './paywall-free-bg-mobile-rebrand.png';

export const PaywallFreeBgMobileJpg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'paywall pro bg', ...rest } = props;

  return <Image src={PaywallProBgRebrand} alt={alt} {...rest} />;
};
